import { Button, Step, StepContent, StepLabel, Stepper, } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { campaignFormInitialValues, } from '../../commons/assets/InitialValues';
import { EditableTextField } from '../../commons/EditableTextField';
import { SubName } from '../../commons/style/MUI.Styles';
import { campaignFormValidationSchema } from '../../commons/validation/CampaignValidation';
import { ButtonWrapper, ConfigWrapper, FormWrapper, Title, Wrapper, } from './CampaignConfigurator.Styles';
import { CustomAttributes } from './CustomAttributes';
import { GeneralForm } from './GeneralForm';
import { PacingForm } from './PacingForm';
import { AccountSelector } from '../../commons/AccountSelector';
import { accounts } from '../../../frontend-config';
import { config_baseURL, set_config_baseURL, baseURL, } from '../../../api/utils';
export var CampaignConfigurator = function (_a) {
    var onDiscardClick = _a.onDiscardClick, campaigns = _a.campaigns, creating = _a.creating, copied = _a.copied, groups = _a.groups, queues = _a.queues, contactLists = _a.contactLists, availableCallerIDs = _a.availableCallerIDs, contactFlows = _a.contactFlows, contactList = _a.contactList, getOneContactList = _a.getOneContactList, dialerDefaults = _a.dialerDefaults, accessLevel = _a.accessLevel, selectedRow = _a.selectedRow, readOnly = _a.readOnly, updateCampaignByID = _a.updateCampaignByID, addCampaign = _a.addCampaign, onAddGroup = _a.onAddGroup, onEditGroup = _a.onEditGroup, onDeleteGroup = _a.onDeleteGroup, onAlert = _a.onAlert, onAccountChange = _a.onAccountChange;
    var step = useState(0)[0];
    var _b = useState(true), openStepOne = _b[0], setOpenStepOne = _b[1];
    var _c = useState(true), openStepTwo = _c[0], setOpenStepTwo = _c[1];
    var _d = useState(true), openStepThree = _d[0], setOpenStepThree = _d[1];
    var _e = useState(selectedRow), selectedCampaign = _e[0], setSelectedCampaign = _e[1];
    var _f = useState(), configAccount = _f[0], setConfigAccount = _f[1];
    var _g = useState(''), campaignMode = _g[0], setCampaignMode = _g[1];
    var handleDiscard = function (resetForm) {
        resetForm();
        onDiscardClick();
        setSelectedCampaign(null);
    };
    var handleSubmit = function (submitForm) {
        submitForm();
    };
    useEffect(function () {
        setSelectedCampaign(JSON.parse(JSON.stringify(selectedRow)));
        if (selectedRow && selectedRow.prjacc) {
            setConfigAccount(accounts.find(function (a) { return a.url === selectedRow.prjacc.url; }));
            set_config_baseURL(selectedRow.prjacc.url);
            onAccountChange(selectedRow.prjacc.url);
        }
        else if (selectedRow && JSON.stringify(selectedRow) !== '{}') {
            setConfigAccount(accounts.find(function (a) { return a.url === baseURL(); }));
            onAccountChange(baseURL());
            set_config_baseURL(baseURL());
        }
        else {
            setConfigAccount(accounts.find(function (a) { return a.url === config_baseURL(); }));
            onAccountChange(config_baseURL());
        }
    }, [selectedRow]);
    var setFormValues = function (setValues) {
        var _a, _b;
        var campaign = selectedCampaign;
        if (campaign && Object.keys(campaign).length > 0) {
            if (campaign.BaseConfig.CallingMode === 'agentless') {
                setCampaignMode('agentless');
            }
            if (campaign.BaseConfig.CallingMode === 'power') {
                setCampaignMode('power');
            }
            var template = {
                campaignConfigName: campaign.CampaignName,
                callingMode: campaign.BaseConfig.CallingMode,
                group: campaign.BaseConfig.CampaignGroupId,
                queue: campaign.BaseConfig.Queue,
                contactList: campaign.BaseConfig.ContactListConfigID,
                defaultCallerID: campaign.BaseConfig.Callerid,
                weight: campaign.BaseConfig.Weight,
                activePhoneFields: campaign.BaseConfig.ActivePhoneTypes,
                contactFlowOverride: campaign.BaseConfig.ContactFlowOverride || '',
                initialCallsPerAgent: campaign.Pacing.InitialCPA,
                maxPerAgent: campaign.Pacing.MaxCPA || (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.MaxCPA) || 0,
                initialCpaMode: campaign.Pacing.InitialCPAMode,
                initialPacing: campaign.Pacing.InitialDuration,
                aBAIncrement: campaign.Pacing.AbaIncrement,
                cPAModifier: campaign.Pacing.CpaModifier,
                aBACalculation: campaign.Pacing.AbaCalculation,
                aBATargetRate: campaign.Pacing.AbaTargetRate,
                concurrentCalls: campaign.Pacing.ConcurrentCalls || 0,
                customAttributes: (_b = (_a = campaign === null || campaign === void 0 ? void 0 : campaign.CustomAttributes) === null || _a === void 0 ? void 0 : _a.ActiveAttributes) === null || _b === void 0 ? void 0 : _b.map(function (c) { return ({
                    name: c.Name,
                    value: c.Value
                }); })
            };
            setValues(template);
        }
    };
    var onSend = function (value, resetForm) {
        var campaign = {
            CampaignName: value.campaignConfigName,
            BaseConfig: {
                CallingMode: value.callingMode,
                CampaignGroupId: value.group,
                Queue: value.queue,
                ContactListConfigID: value.contactList,
                Callerid: value.defaultCallerID,
                ContactFlowOverride: value.contactFlowOverride,
                Weight: value.weight,
                ActivePhoneTypes: value.activePhoneFields
            },
            Pacing: {
                // InitialCPAMode: value.initialCpaMode,
                InitialCPA: value.initialCallsPerAgent,
                MaxCPA: null,
                InitialDuration: value.initialPacing,
                AbaIncrement: value.aBAIncrement,
                CpaModifier: value.cPAModifier,
                // AbaCalculation: value.aBACalculation,
                AbaTargetRate: value.aBATargetRate,
                ConcurrentCalls: value.concurrentCalls
            },
            CustomAttributes: {
                ActiveAttributes: value.customAttributes.map(function (c) { return ({
                    Name: c.name,
                    Value: c.value
                }); })
            }
        };
        if (value.callingMode === 'power') {
            campaign.Pacing = {
                InitialCPAMode: value.initialCpaMode,
                InitialCPA: value.initialCallsPerAgent,
                MaxCPA: value.maxPerAgent,
                InitialDuration: value.initialPacing,
                AbaIncrement: value.aBAIncrement,
                CpaModifier: value.cPAModifier,
                AbaCalculation: value.aBACalculation,
                AbaTargetRate: value.aBATargetRate
            };
        }
        if (!creating && !copied) {
            updateCampaignByID(campaign, selectedRow.id, selectedRow);
        }
        else {
            addCampaign(campaign);
        }
        handleDiscard(resetForm);
    };
    var checkCampaignName = function (formValues) {
        var lowerCheck = formValues.campaignConfigName.toLowerCase();
        var campaignCheck = campaigns.filter(function (camp) {
            return camp.CampaignName.toLowerCase() === lowerCheck;
        });
        return (campaignCheck.length === 0 ||
            (campaignCheck.length > 0 &&
                !creating &&
                formValues.campaignConfigName === (selectedCampaign === null || selectedCampaign === void 0 ? void 0 : selectedCampaign.CampaignName)));
    };
    return (React.createElement(Wrapper, null,
        React.createElement(FormWrapper, null,
            React.createElement(Formik, { initialValues: campaignFormInitialValues(dialerDefaults), validationSchema: campaignFormValidationSchema(dialerDefaults), onSubmit: function (values, _a) {
                    var setSubmitting = _a.setSubmitting, resetForm = _a.resetForm;
                    if (checkCampaignName(values)) {
                        onSend(values, resetForm);
                    }
                    else {
                        onAlert('This Campaign Name is already in use please use a new one', 'warning');
                    }
                    setSubmitting(false);
                } }, function (_a) {
                var submitForm = _a.submitForm, isSubmitting = _a.isSubmitting, resetForm = _a.resetForm, setValues = _a.setValues, setFieldTouched = _a.setFieldTouched, setFieldValue = _a.setFieldValue, handleChange = _a.handleChange, values = _a.values, errors = _a.errors, registerField = _a.registerField;
                return (React.createElement(Form, null,
                    useEffect(function () {
                        setTimeout(function () {
                            setFormValues(setValues);
                        }, 400);
                    }, [selectedCampaign]),
                    React.createElement(Title, { variant: 'h5', gutterBottom: true },
                        React.createElement(Field, { name: 'campaignConfigName', label: 'Campaign Name', component: EditableTextField }),
                        React.createElement(SubName, { variant: 'body2' }, selectedCampaign && selectedCampaign.id)),
                    React.createElement(Divider, null),
                    React.createElement(ConfigWrapper, null,
                        React.createElement(AccountSelector, { initialValue: configAccount, onValueChange: function (account) {
                                if (account && account !== 'All') {
                                    setConfigAccount(account);
                                    onAccountChange(account.url);
                                    set_config_baseURL(account.url);
                                }
                            }, fullWidth: true, noAll: true, disabled: !creating })),
                    React.createElement(Divider, null),
                    React.createElement(Stepper, { activeStep: step, orientation: 'vertical' },
                        React.createElement(Step, { active: openStepOne },
                            React.createElement(StepLabel, { onClick: function () {
                                    setOpenStepOne(!openStepOne);
                                } }, "General"),
                            React.createElement(StepContent, null,
                                React.createElement(GeneralForm, { accessLevel: accessLevel, groups: groups, queues: queues, contactLists: contactLists, availableCallerIDs: availableCallerIDs, contactFlows: contactFlows, contactList: contactList, getOneContactList: getOneContactList, handleChange: handleChange, formValues: values, setCampaignMode: setCampaignMode, registerField: registerField, onAddGroup: function (group) {
                                        onAddGroup(group);
                                    }, onEditGroup: function (group, id, initialGroup) {
                                        onEditGroup(group, id, initialGroup);
                                    }, onDeleteGroup: function (id) { return onDeleteGroup(id); } }))),
                        React.createElement(Step, { active: openStepTwo },
                            React.createElement(StepLabel, { onClick: function () {
                                    setOpenStepTwo(!openStepTwo);
                                } }, "Pacing"),
                            React.createElement(StepContent, null,
                                React.createElement(PacingForm, { isCampaignConfig: true, formValues: values, campaignMode: campaignMode, errors: errors }))),
                        React.createElement(Step, { active: openStepThree },
                            React.createElement(StepLabel, { onClick: function () {
                                    setOpenStepThree(!openStepThree);
                                } }, "Custom Attributes"),
                            React.createElement(StepContent, null,
                                React.createElement(CustomAttributes, null))),
                        React.createElement(Step, { expanded: true },
                            React.createElement(StepContent, null,
                                React.createElement(ButtonWrapper, null,
                                    React.createElement(Button, { variant: 'contained', color: 'primary', disabled: isSubmitting || readOnly, onClick: function () { return handleSubmit(submitForm); } }, creating === true ? 'Create' : 'Update'),
                                    React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () { return handleDiscard(resetForm); } }, readOnly ? 'Close' : 'Discard')))))));
            }))));
};
CampaignConfigurator.defaultProps = {
    title: 'Campaign Name'
};
//# sourceMappingURL=CampaignConfigurator.js.map